import { ArrowLeft, X } from "lucide-react";
import React, { useEffect, useMemo, useState } from "react";
import ModalDefault from "../ui/modal-default";
import { Button } from "../ui/button";
import { createPortal } from "react-dom";

const PoliticasModal = ({
  isOpen,
  onClose,
  titulo = "AVISO DE PRIVACIDADE DO ENERGIA",
  tipo = "politicas",
}) => {
  const [jaAceitou, setJaAceitou] = useState(false);

  useEffect(() => {
    const storageKey = tipo === "termos" ? "termos_aceitos" : "politica_aceita";
    const valorStorage = localStorage.getItem(storageKey);
    const valorLido = tipo === "termos" ? "TXT_TERMO_LIDO" : "TXT_POLITICAS_LIDO";
    setJaAceitou(valorStorage === valorLido);
  }, [isOpen, tipo]);

  const registrarInteracao = (acao) => {
    let valorParaSalvar = "";

    if (tipo === "termos") {
      valorParaSalvar = acao === "lido" ? "TXT_TERMO_LIDO" : "TXT_TERMO_NaoLIDO";
    } else if (tipo === "politicas") {
      valorParaSalvar =
        acao === "lido" ? "TXT_POLITICAS_LIDO" : "TXT_POLITICAS_NaoLIDO";
    }

    const interacao = {
      valor: valorParaSalvar,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    const interacoes = JSON.parse(localStorage.getItem("interacoes_legais") || "[]");
    interacoes.push(interacao);
    localStorage.setItem("interacoes_legais", JSON.stringify(interacoes));
  };

  const handleAceitar = () => {
    if (!jaAceitou) {
      const valorParaSalvar = tipo === "termos" ? "TXT_TERMO_LIDO" : "TXT_POLITICAS_LIDO";
      const storageKey = tipo === "termos" ? "termos_aceitos" : "politica_aceita";

      localStorage.setItem(storageKey, valorParaSalvar);
      setJaAceitou(true);
      registrarInteracao("lido");
    }
    onClose();
  };

  const handleFechar = () => {
    if (!jaAceitou) {
      const valorParaSalvar =
        tipo === "termos" ? "TXT_TERMO_NaoLIDO" : "TXT_POLITICAS_NaoLIDO";
      const storageKey = tipo === "termos" ? "termos_aceitos" : "politica_aceita";

      localStorage.setItem(storageKey, valorParaSalvar);
      registrarInteracao("nao_lido");
    }
    onClose();
  };


  const politicasItems = useMemo(
    () => [
      {
        id: 0,
        Componente: (
          <p className="text-gray-700 text-sm md:text-base leading-relaxed">
            <strong>Data da última atualização:</strong> 04 de fevereiro de 2026
          </p>
        ),
      },

      {
        id: 1,
        Componente: (
          <div className="flex flex-col gap-3">
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Nós, do Claro S.A (“Claro”) em parceria com a Thopen Energia S.A.
              (Thopen Energia), ambas na posição de Controladoras dos Dados
              Pessoais (“Controladoras”), desejamos manter uma relação de confiança
              e transparência com todos com quem nos relacionamos.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Assim, elaboramos este Aviso de Privacidade (“Aviso”) para ajudar
              você a entender como serão tratadas suas informações no escopo do
              projeto Claro Energia, e como você pode exercer os seus direitos
              relativos a essas informações.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Para saber mais sobre como a Claro e a Thopen Energia tratam seus
              dados pessoais em operações diversas do projeto Claro Energia,
              acesse seus respectivos Avisos de Privacidade, disponíveis nos links
              abaixo:
            </p>

            <div className="flex flex-col gap-2">
              <a
                href="https://www.claro.com.br/privacidade/politica-de-privacidade"
                target="_blank"
                rel="noreferrer noopener"
                className="text-[#DA291C] font-medium underline break-words hover:opacity-90"
              >
                https://www.claro.com.br/privacidade/politica-de-privacidade
              </a>

              <a
                href="https://thopenergy.com.br/politica-de-privacidade/"
                target="_blank"
                rel="noreferrer noopener"
                className="text-[#DA291C] font-medium underline break-words hover:opacity-90"
              >
                https://thopenergy.com.br/politica-de-privacidade/
              </a>
            </div>
          </div>
        ),
      },

      {
        id: 2,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">1. Quais dados coletamos?</p>

            <p className="text-gray-800 font-medium">Dados cadastrais e de qualificação</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Nome completo, CPF, RG, CNH, estado civil, nacionalidade, profissão,
              assinatura, e-mail, endereço completo/região, telefone/WhatsApp,
              categoria de associado, indicação de representante legal de empresa.
            </p>

            <p className="text-gray-800 font-medium">Dados da conta de energia</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Número da unidade consumidora, número do relógio, número da conta ou
              contrato com a distribuidora, histórico de consumo de energia - kWh
              utilizados no período, valor da fatura, informações sobre débitos
              anteriores ou parcelamentos.
            </p>

            <p className="text-gray-800 font-medium">Dados financeiros e de pagamento</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Desconto aplicável e score de crédito.
            </p>

            <p className="text-gray-800 font-medium">Dados de Navegação</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Identificadores online, como os IDs de cookies e o endereço IP (que é
              processado para fins de geolocalização); sistema operacional;
              navegador; resolução de tela; dados de interação, como páginas
              visitadas, tempo de permanência, cliques, movimentos do mouse e
              padrões de rolagem.
            </p>

            <p className="text-gray-800 font-medium">Mídia</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Imagens de documentos de identificação.
            </p>
          </div>
        ),
      },

      {
        id: 3,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">2. Para que precisamos dos seus dados?</p>

            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>
                Viabilizar sua adesão ao benefício de desconto na fatura de energia.
                Poderemos realizar a análise de elegibilidade e procedimentos necessários
                para contratação do benefício.
              </li>
              <li>
                Promover análise de crédito, realizada exclusivamente pela Thopen Energia
                para proteção de seu crédito, visando viabilizar sua adesão ao benefício
                de desconto na conta de energia de forma segura.
              </li>
              <li>Exercer nossos direitos em processos judiciais, administrativos ou arbitrais.</li>
              <li>
                Cumprir nossas obrigações legais e regulatórias, ou até ordens judiciais
                ou ordens provenientes de outras autoridades competentes.
              </li>
              <li>
                Viabilizar nossas atividades em prol de nosso interesse legítimo, nos
                comunicando com você, personalizando sua experiência para oferecer produtos,
                serviços e conteúdo que correspondam aos seus interesses e perfil, divulgando
                campanhas de marketing e publicidade e viabilizando sua participação em promoções.
              </li>
              <li>
                Fornecer nossos produtos e serviços e executar nosso contrato com você.
                Precisamos coletar seus dados para, por exemplo, cadastrar seu contrato como
                cliente, avaliar sua condição de representante legal para cumprimento de contrato
                firmado com a pessoa jurídica que você representa, processar o desconto relacionado
                ao benefício Claro Energia.
              </li>
            </ul>
          </div>
        ),
      },

      {
        id: 4,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">3. E como coletamos seus dados?</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Podemos obter seus dados pessoais das seguintes formas:
            </p>

            <p className="text-gray-800 font-medium">Informações fornecidas diretamente por você:</p>
            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>
                Ao preencher formulários de cadastro durante o seu relacionamento conosco em nossas
                lojas físicas e no website do Claro Energia;
              </li>
              <li>
                Ao navegar no aplicativo e website da Claro, ou quando você solicita informações
                para a contratação online dos nossos serviços;
              </li>
              <li>Ao nos enviar mensagens pelo WhatsApp.</li>
              <li>Ao compartilhar suas informações conosco por quaisquer canais de contato.</li>
            </ul>

            <p className="text-gray-800 font-medium">Informações obtidas de terceiros:</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Poderemos obter informações de terceiros, como:
            </p>
            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>Empresas afiliadas;</li>
              <li>
                Consultores, prestadores de serviços e fornecedores, quando nos auxiliam a oferecer
                produtos e serviços ou desenvolver campanhas de marketing;
              </li>
              <li>
                Bureaus de dados que nos subsidiam com informações necessárias para a análise de crédito.
              </li>
            </ul>

            <p className="text-gray-800 font-medium">Informações obtidas automaticamente:</p>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Por meio de cookies, a partir dos dispositivos que você utiliza para acessar nossa página.
            </p>
          </div>
        ),
      },

      {
        id: 5,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">4. Dados pessoais de crianças e adolescentes</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Nós não temos o objetivo de coletar ou, de alguma forma, tratar dados pessoais de menores de 18
              (dezoito) anos para as atividades atreladas à Claro Energia.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Caso tenhamos conhecimento de que, porventura, coletamos dados de crianças ou adolescentes,
              adotaremos as providências necessárias para excluir essas informações de nossas bases de forma segura.
            </p>
          </div>
        ),
      },

      {
        id: 6,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">5. O que são cookies e como os utilizamos?</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Cookies são arquivos que armazenam temporariamente algumas informações básicas quando você visita o nosso site.
              Por aqui, nós os utilizamos para melhorar e personalizar sua experiência de navegação e para gerar publicidade.
              Para mais informações, acesse{" "}
              <a
                href="https://thopenergy.com.br/privacidade/"
                target="_blank"
                rel="noreferrer noopener"
                className="text-[#DA291C] font-medium underline break-words hover:opacity-90"
              >
                https://thopenergy.com.br/privacidade/
              </a>
            </p>
          </div>
        ),
      },

      {
        id: 7,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">6. Por quanto tempo armazenamos seus dados?</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Armazenamos os seus dados apenas pelo tempo necessário para atingir as finalidades informadas a você neste Aviso.
              Manteremos os seus dados pessoais com cuidado e responsabilidade, respeitando o mais alto nível de segurança de mercado.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Quando for preciso reter seus dados por mais tempo, analisaremos:
            </p>

            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>
                Se temos uma obrigação legal, regulatória, contratual ou imposta por autoridade competente de reter dados pessoais;
              </li>
              <li>
                Se seus dados são necessários para manter registros históricos, comerciais e financeiros precisos ou para atender
                determinações internas da Claro ou da Thopen Energia, inclusive para exercício regular de direitos;
              </li>
              <li>
                Se os dados são necessários para cumprir a lei, como nos casos em que for preciso fornecer dados às autoridades públicas competentes.
              </li>
            </ul>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Para saber mais informações sobre os prazos de armazenamento de seus dados, entre em contato com nossos Encarregados,
              através dos e-mails mencionados no tópico 10.
            </p>
          </div>
        ),
      },

      {
        id: 8,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">7. Como seus dados são protegidos?</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Para manter sua privacidade e segurança de suas informações, nós utilizamos:
            </p>

            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>
                Soluções e medidas técnicas de segurança compatíveis com os padrões internacionais e com as boas práticas do setor,
                buscando preservar a inviolabilidade dos dados;
              </li>
              <li>
                Medidas de segurança apropriadas contra os riscos de perda acidental ou ilegal, alteração, divulgação ou acessos não autorizados.
              </li>
            </ul>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Apesar do nosso compromisso com a adoção das melhores práticas de segurança da informação, é importante destacar que nenhum sistema
              ou método de transmissão de dados pela internet é totalmente seguro. Por isso, recomendamos que você também adote cuidados para proteger
              seus dados pessoais.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Caso queira mais informações sobre as medidas de privacidade e segurança que implementamos, ou em caso de qualquer dúvida ou suspeita de
              violação de dados pessoais, você pode entrar em contato com o Encarregado de Dados (DPO) da Thopen Energy pelo e-mail:{" "}
              <a
                href="mailto:dpo@thopenergy.com.br"
                className="text-[#DA291C] font-medium underline hover:opacity-90"
              >
                dpo@thopenergy.com.br
              </a>
              .
            </p>
          </div>
        ),
      },

      {
        id: 9,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">8. Seus dados podem ser compartilhados?</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Seus dados serão compartilhados entre Claro e Thopen Energia para as finalidades descritas neste Aviso.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Quando necessário, também poderemos compartilhar seus dados com terceiros, que podem ser:
            </p>

            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>
                Autoridades administrativas e judiciais, para cumprimento de obrigação legal ou para auxiliar na investigação de atividades suspeitas
                ou ilegais, mediante requisição formal dessas autoridades;
              </li>
              <li>
                Escritórios de advocacia, assessorias jurídicas e outros representantes legais, quando necessário para defender nossos interesses em
                procedimentos administrativos, arbitrais ou judiciais;
              </li>
              <li>
                Empresas do mesmo grupo ou afiliadas, para possibilitar a operacionalização das nossas atividades, incluindo as atividades relacionadas
                ao processamento dos descontos e dos pagamentos realizados por você.;
              </li>
              <li>
                Parceiros de negócios, fornecedores e prestadoras de serviço, para viabilizar a atuação de canais de comunicação e de marketing e fornecer
                estrutura necessária aos nossos serviços, incluindo, quando necessário, inteligência artificial para validação dos documentos fornecidos por
                você e extração de informações desses documentos, propiciando otimização às nossas operações.
              </li>
            </ul>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Sempre que realizarmos o compartilhamento de seus dados pessoais, utilizaremos salvaguardas adequadas, tais como instrumentos contratuais,
              para assegurar que os terceiros que receberem os seus dados pessoais confiram a eles a mesma proteção que nós.
            </p>
          </div>
        ),
      },

      {
        id: 10,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">9. Transferência internacional de dados pessoais</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              A Transferência Internacional de Dados Pessoais ocorre quando compartilhamos dados pessoais com empresas localizadas fora do Brasil.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Essa transferência pode acontecer devido ao uso de nossa ferramenta de CRM, que auxilia na gestão do relacionamento com clientes, registro de
              interações e suporte às atividades comerciais e operacionais. A infraestrutura dessa ferramenta está hospedada em um provedor de nuvem situado
              nos Estados Unidos, o que implica na transferência dos dados utilizados para esse país.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Essa transferência internacional ocorrerá enquanto mantivermos o contrato com o fornecedor da ferramenta e/ou tivermos uma finalidade legítima
              para tratar os seus dados pessoais na condição de nosso cliente, sempre em conformidade com este Aviso.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Nessas transferências são utilizados métodos para garantir que seus dados permaneçam seguros como: utilização de provedores de nuvem com padrões
              reconhecidos de segurança da informação e controle de acesso às informações armazenadas, delimitando a permissão e os privilégios de acesso de acordo
              com as responsabilidades envolvidas;.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Todas as transferências internacionais de dados pessoais observarão as regras estabelecidas na Lei nº 13.709/2018 (LGPD) e na Resolução CD/ANPD nº 19/2024.
            </p>
          </div>
        ),
      },

      {
        id: 11,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">
              10. Quais são os seus direitos como titular de dados pessoais e como você pode exercê-los?
            </p>

            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>Saber se tratamos seus dados pessoais e ter acesso a esses dados;</li>
              <li>Pedir a correção de dados incompletos, inexatos ou desatualizados;</li>
              <li>
                Pedir a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tenham sido tratados em desconformidade com a lei;
              </li>
              <li>Solicitar a portabilidade dos dados a outro fornecedor de serviço ou produto;</li>
              <li>
                Pedir a revisão de decisões tomadas unicamente com base em tratamento automatizado de dados, que afetem seus interesses;
              </li>
              <li>
                Ter informações sobre a possibilidade de não consentir com o tratamento de seus dados e entender as consequências da negativa;
              </li>
              <li>Solicitar a revogação do consentimento, caso fornecido;</li>
              <li>Pedir a eliminação de dados tratados com base em seu consentimento;</li>
              <li>Saber com quem seus dados são compartilhados;</li>
              <li>
                Se opor ao tratamento de seus dados realizado com fundamento em uma das hipóteses de dispensa do consentimento, em caso de descumprimento ao disposto na LGPD;
              </li>
              <li>
                Solicitar acesso às cláusulas-padrão contratuais quando for o mecanismo utilizado para subsidiar as transferências internacionais de dados.
              </li>
            </ul>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Você poderá exercer seus direitos a qualquer momento e de forma gratuita. É só entrar em contato com nossos Encarregados nos canais indicados a seguir:
            </p>

            <div className="space-y-2">
              <div>
                <p className="text-gray-800 font-medium">CLARO:</p>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                  Maria Tereza David —{" "}
                  <a
                    href="mailto:dpo@claroatendimento.com.br"
                    className="text-[#DA291C] font-medium underline hover:opacity-90"
                  >
                    dpo@claroatendimento.com.br
                  </a>
                </p>
              </div>

              <div>
                <p className="text-gray-800 font-medium">THOPEN ENERGIA:</p>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                  Fernando Fleider. —{" "}
                  <a
                    href="mailto:dpo@thopenergy.com.br"
                    className="text-[#DA291C] font-medium underline hover:opacity-90"
                  >
                    dpo@thopenergy.com.br
                  </a>
                </p>
              </div>
            </div>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Antes de respondermos a qualquer requisição, poderemos pedir que você nos forneça algumas informações ou documentos para confirmar sua identidade.
              Isso porque não atenderemos requisições que envolvam dados pessoais e documentos de outros titulares, exceto se houver procuração, poder parental
              ou outra hipótese que autorize o exercício do direito de outro titular por você.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Além disso, em casos específicos, é possível que a sua requisição não seja atendida. Se isso acontecer, nós explicaremos os motivos.
            </p>
          </div>
        ),
      },

      {
        id: 12,
        Componente: (
          <div className="space-y-2">
            <p className="text-gray-800 font-semibold">11. Ficou com dúvidas?</p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Estamos aqui para te ajudar! Se permanecerem dúvidas relacionadas à proteção dos seus dados pessoais e/ou a este Aviso de Privacidade, não hesite em contatar nossos Encarregados.
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed">
              Se tiver qualquer dúvida, é só entrar em contato com a gente pelos canais:
            </p>

            <ul className="list-disc pl-5 text-gray-700 text-sm md:text-base leading-relaxed space-y-1">
              <li>
                <a
                  href="mailto:dpo@thopenergy.com.br"
                  className="text-[#DA291C] font-medium underline hover:opacity-90"
                >
                  dpo@thopenergy.com.br
                </a>
              </li>
              <li>
                <a
                  href="mailto:dpo@claroatendimento.com.br"
                  className="text-[#DA291C] font-medium underline hover:opacity-90"
                >
                  dpo@claroatendimento.com.br
                </a>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );


return createPortal(
  <ModalDefault isOpen={isOpen} onClose={handleFechar}>
    <div className="bg-white rounded-lg shadow-xl w-full max-w-[90vw] md:max-w-[600px] lg:max-w-[700px] max-h-[90vh] flex flex-col font-sans mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center p-6 border-b border-gray-200">
        <button
          onClick={handleFechar}
          className="md:hidden p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
          aria-label="Voltar"
        >
          <ArrowLeft size={24} className="text-gray-600" />
        </button>

        <h2 className="text-xl md:text-2xl font-bold text-gray-800 flex-1 text-center md:text-left">
          {titulo}
        </h2>

        <button
          onClick={handleFechar}
          className="hidden md:block p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
          aria-label="Fechar modal"
        >
          <X size={24} className="text-gray-600" />
        </button>
      </div>

      {/* Content with scroll */}
      <div className="flex-1 overflow-y-auto p-6 max-h-[60vh]">
        <div className="flex flex-col gap-4 text-left">
          {politicasItems.map((item) => (
            <React.Fragment key={item.id}>{item.Componente}</React.Fragment>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="p-6 border-t border-gray-200 bg-gray-50">
        <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
          <Button
            variant="default"
            className="!bg-claro-red !text-white w-full !rounded-full opacity-100 hover:!bg-claro-red max-w-fit "
            disabled={jaAceitou}
            onClick={handleAceitar}
          >
            {jaAceitou ? 'Já aceito ✓' : 'Li e entendi'}
          </Button>
        </div>
      </div>
    </div>
  </ModalDefault>,
  document.body
);
};

export default PoliticasModal;
